export default __webpack_public_path__ + "static/media/google-play.9171221a.svg";